import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Arende } from '../../interfaces/arende.interface';

@Injectable()
export class AllaArendenService {
  constructor(
    private http: HttpClient,
    @Inject('API_URL') private apiUrl: string) {
  }

  public getAllaArenden(instance: string): Observable<Arende[]> {
    return this.http.get<Arende[]>(`${this.apiUrl}${instance}/arende/get`);
  }
}
